import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { SRGBColorSpace } from 'three'

export default class ModelFactory {
  constructor() {
    this._loader = new GLTFLoader()
    // Setup DRACOLoader correctly for modern Three.js
    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath('/assets/vendor/draco/')
    this._loader.setDRACOLoader(dracoLoader)
    this._models = {}
  }

  loadModel(url) {
    if (this._models[url]) {
      return this._models[url].then((o) => o.clone())
    }

    return (this._models[url] = new Promise((resolve, reject) => {
      this._loader.load(
        url,
        function (gltf) {
          // Three.js v0.180.0: Fix texture colorSpace for GLTF models
          // GLTFLoader should handle this, but we ensure it's correct
          if (gltf.scene) {
            gltf.scene.traverse((node) => {
              if (node.isMesh) {
                // Handle both single materials and material arrays
                const materials = Array.isArray(node.material) ? node.material : [node.material]

                materials.forEach((material) => {
                  if (!material) return

                  // Three.js v0.180.0: Material properties are handled correctly with useLegacyLights
                  // No modifications needed - materials render correctly with r107 lighting behavior

                  // List of material properties that contain color textures
                  const colorTextureProps = ['map', 'emissiveMap', 'specularMap']

                  colorTextureProps.forEach((prop) => {
                    if (material[prop] && material[prop].isTexture) {
                      // Ensure textures use sRGB color space (should be automatic with GLTFLoader)
                      material[prop].colorSpace = SRGBColorSpace
                      material[prop].needsUpdate = true
                    }
                  })

                  material.needsUpdate = true
                })
              }
            })
          }

          resolve(gltf.scene)
        },
        undefined,
        reject
      )
    }))
  }

  getModels() {
    return this._models
  }
}
